import URlS from "./urls";
import {
  IMapFiltersRequest,
  IMapFiltersResponse,
  IMapMarkersRequest,
  IMapMarkersResponse,
  IMapSearchListRequest,
  IMapSearchListResponse,
  IMapLngLat
} from "~/types/map.interface";

export async function getMapFilters(
  requestBody: IMapFiltersRequest
): Promise<IMapFiltersResponse> {
  const url = URlS.map.mapFiltersV2;
  const data = await $fetch(url, {
    method: "POST",
    body: { ...requestBody },
  });

  return data as IMapFiltersResponse;
}

export async function getMapSearchList(
  requestBody: IMapSearchListRequest, controller?: AbortController
): Promise<IMapSearchListResponse> {
  const url = URlS.map.mapSearchListV2;
  const data = await $fetch(url, {
    method: "POST",
    body: { ...requestBody },
    signal: controller?.signal
  });

  return data as IMapSearchListResponse;
}

export async function getMapMarkers(
  requestBody: IMapMarkersRequest
): Promise<IMapMarkersResponse> {
  const url = URlS.map.mapMarkersV2;
  const data = await $fetch(url, {
    method: "POST",
    body: { ...requestBody },
  });

  return data as IMapMarkersResponse;
}

export async function getGeographicFeaturesByReverseGeocoding(coords: IMapLngLat): Promise<{ id: string, value: string } | null> {
  const [ lat, lng ] = coords;
  const url = URlS.map.reverseGeocoding(lat, lng);
  return await $fetch(url);
}